module.exports = __webpack_public_path__ + "img/main_logo_small.5bb9ca92.svg";